<template>
  <el-card class="box-card contaier">
    <div class="container">
      <div class="title">
        {{ $t('sidebar.message') }}
      </div>
      <div class="main">
        <el-tabs v-model="activeName">
          <el-tab-pane :label="$t('messages.info')" name="first">
            <div class="content">
              <el-table
                :data="tableData"
                :header-cell-style="{
                  background: '#FDC400',
                  color: '#333',
                  height: '42px',
                }"
              >
                <el-table-column prop="companyNameC" :label="$t('messages.company')">
                  <template slot-scope="scope">
                    <div class="company">
                      <span>{{ scope.row.companyNameC || scope.row.companyNameE }}</span>
                      <span v-if="scope.row.count" class="count">{{ scope.row.count }}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="time" :label="$t('messages.time')"> </el-table-column>
                <el-table-column :label="$t('common.option')">
                  <template slot-scope="scope">
                    <el-button type="text" class="view" @click="view(scope.row)">{{ $t('common.view') }}</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </el-card>
</template>
<script>
import { getLists } from '../../../api/message.js';
export default {
  data() {
    return {
      activeName: 'first',
      tableData: [],
      num: '',
    };
  },
  created() {
    this.getLists();
  },
  methods: {
    view(row) {
      this.$router.push({
        name: 'messageDetail',
        query: {
          sendUserId: row.sendUserId,
          receiveUserId: row.receiveUserId,
        },
      });
    },

    async getLists() {
      try {
        const { data } = await getLists();
        if (data.code === 200) {
          this.tableData = data.data;
          let count = this.unread(this.tableData);
          if (count > 0) {
            this.$emit('getMessage', true);
          } else {
            this.$emit('getMessage', false);
          }
        }
      } catch (err) {
        console.log(err.msg);
      }
    },
    unread(arr) {
      let count = 0;
      arr.forEach((item, index) => {
        if (item.count != 0) {
          count += 1;
        }
      });
      return count;
    },
  },

  beforeRouteLeave(to, from, next) {
    if (to.name == 'messageDetail') {
      let count = this.unread(this.tableData);
      if (count - 1 < 1) {
        this.$emit('getMessage', false);
        next();
      } else {
        this.$emit('getMessage', true);
        next();
      }
    } else {
      next();
    }
  },
};
</script>
<style lang="scss" scoped>
.container {
  min-height: 780px;
  .title {
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 28px;
  }
  .main .content {
    padding: 40px 30px 40px 0px;
    box-sizing: border-box;
    .company {
      display: flex;
      .count {
        width: 24px;
        height: 20px;
        background: #ff190c;
        border-radius: 12px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 20px;
        margin-left: 10px;
        text-align: center;
      }
    }
    .view {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #006fb8;
      line-height: 20px;
    }
  }
}
</style>
<style scoped>
.el-table td,
.el-table >>> th {
  padding: 10px 0;
}
</style>
